export default __webpack_public_path__ + "static/media/MarketCapIcon.3338a388.svg";